export default __webpack_public_path__ + "static/media/teacher.d0c9d407.png";